/**
 * URL utilities for parameter management
 */

/**
 * Reads a parameter from the URL query string (case-insensitive)
 */
export const getUrlParameter = (name: string): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  
  // Try exact match first
  let value = urlParams.get(name);
  
  // If not found, try case-insensitive search
  if (!value) {
    const lowerName = name.toLowerCase();
    urlParams.forEach((val, key) => {
      if (!value && key.toLowerCase() === lowerName) {
        value = val;
      }
    });
  }
  
  // Remove any quotes from the value (e.g. "it" -> it)
  if (value) {
    return value.replace(/^["']|["']$/g, "").trim();
  }
  return null;
};
